// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-1_sMTmS5","foot_link":"foot_link-3_xBq695","list":"list-2caMDxTk","link":"link-3jbamkZI","copyright":"copyright-2HulvJN6"};